<template>
  <div>
    <div class="nav" v-resize="checkResizeForNav">
    <!--  نشان دادن لوگو مورد نظر که برای وسط افتادن نسبت به کل صفحه به طور absolute , relative پیاده سازی شده است . -->
     <div @click="changeRouterToMainPage()" class="logo">
       <img v-if="$vuetify.breakpoint.mobile" width="25" src="../../assets/svg/Logo.svg" alt="">
       <img v-else width="32" src="../../assets/svg/Logo.svg" alt="">
     </div>

     <div class="navbar">
       <!--     این قسمت آیکون منو برای اندازه موبایل را نشان می دهد در غیر اینصورت دیو قسمت کلاس پروفایل نشان دهنده در اندازه وب و
      بیشتراز 600 پیکسل خواد بود که درصورت کلیک این قسمت دراور باز خواهد شد.-->
       <v-app-bar-nav-icon color="white" v-if="$vuetify.breakpoint.smAndDown"  @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
<!--       <div v-else class="profile">
          &lt;!&ndash;     این آواتار برای نشان دادن عکس کاربری است.  &ndash;&gt;
         <v-avatar>
           <svg xmlns="http://www.w3.org/2000/svg"  width="45" height="45" viewBox="0 0 45 45">
             <defs>
               <clipPath id="clip-path">
                 <circle id="Ellipse_5" data-name="Ellipse 5" cx="22.5" cy="22.5" r="22.5" transform="translate(1271 47)" :fill="personColor"/>
               </clipPath>
             </defs>
             <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-1271 -47)" clip-path="url(#clip-path)">
               <g id="man" transform="translate(1271 47)">
                 <path id="Path_1920" data-name="Path 1920" d="M23,0A22.754,22.754,0,0,1,46,22.5,22.754,22.754,0,0,1,23,45,22.754,22.754,0,0,1,0,22.5,22.754,22.754,0,0,1,23,0Z" :fill="personColor"/>
                 <g id="Group_19" data-name="Group 19" transform="translate(5.143 29.835)">
                   <path id="Path_74" data-name="Path 74" d="M25.1,35.709c-.036,0-.072.035-.109.035s-.072-.035-.109-.035Z" transform="translate(-7.134 -33.406)" fill="#84dbff"/>
                   <path id="Path_75" data-name="Path 75" d="M41.3,39.988a23.31,23.31,0,0,1-35.713,0C8.6,36.055,13.2,34.106,16.964,33.15a12.133,12.133,0,0,0,.978,5.386c1.268-2.835,5.506-3.083,5.506-3.083s4.238.248,5.469,3.083a11.606,11.606,0,0,0,.978-5.386C33.7,34.106,38.334,36.055,41.3,39.988Z" transform="translate(-5.591 -33.15)" fill="#84dbff"/>
                 </g>
                 <path id="Path_76" data-name="Path 76" d="M29.729,30.555v.035c0,.354-.181,2.622-5.071,4.429h-.217c-4.89-1.807-5.071-4.075-5.071-4.429v-.035a6.1,6.1,0,0,1,.217-1.382C21,30.909,22.7,32.079,24.55,32.079s3.55-1.169,4.962-2.906A6.1,6.1,0,0,1,29.729,30.555Z" transform="translate(-1.55 -2.917)" fill="#fff"/>
                 <g id="Group_20" data-name="Group 20" transform="translate(16.483 27.638)">
                   <path id="Path_77" data-name="Path 77" d="M30.18,30.709s.254,2.551-5.18,4.535c0,0,4.238.248,5.469,3.083C30.542,38.4,32.969,32.232,30.18,30.709Z" transform="translate(-18.483 -30.709)" fill="#54c0eb"/>
                   <path id="Path_78" data-name="Path 78" d="M19.254,30.709c-2.789,1.524-.362,7.689-.29,7.583,1.268-2.835,5.469-3.083,5.469-3.083C19,33.26,19.254,30.709,19.254,30.709Z" transform="translate(-17.916 -30.709)" fill="#54c0eb"/>
                 </g>
                 <g id="Group_21" data-name="Group 21" transform="translate(13.424 9.577)">
                   <path id="Path_79" data-name="Path 79" d="M31.964,19.737a10,10,0,0,1-2.934,5.811,6.972,6.972,0,0,1-.978.815l-.58-1.807h-6.23l-.58,1.807c-1.159-.85-3.586-3.224-3.622-5.457-1.014-12.72,8.946-10.028,8.946-10.028C32.688,10.418,32.471,16.194,31.964,19.737Z" transform="translate(-14.782 -10.641)" fill="#fff"/>
                   <path id="Path_80" data-name="Path 80" d="M34.564,22.929a3.682,3.682,0,0,1-1.847,1.594,14.824,14.824,0,0,0,.652-1.772v-.035l.435-1.594h-.036c.145-.531.29-1.063.4-1.594a1.045,1.045,0,0,1,.435.142C35.4,20.165,35.361,21.618,34.564,22.929Z" transform="translate(-16.041 -11.529)" fill="#fff"/>
                   <path id="Path_81" data-name="Path 81" d="M17.068,24.535a3.682,3.682,0,0,1-1.847-1.594c-.833-1.311-.833-2.764-.036-3.224.072-.035.109-.071.181-.071a23.765,23.765,0,0,0,1.05,3.154A16.916,16.916,0,0,0,17.068,24.535Z" transform="translate(-14.591 -11.541)" fill="#fff"/>
                 </g>
                 <path id="SVGCleanerId_0" d="M28.085,6.63c.29-3.26-5-3.047-5-3.047a10.1,10.1,0,0,0-8.874,8.433L15.3,10.74c-1.7,3.65.869,9.921,1.087,10.417,1.34,4.358,4.31,8.362,7.751,8.362s6.411-4,7.751-8.362h0v-.035c.145-.531.29-1.063.4-1.594H32.25c.724-2.835,1.521-5.7,1.521-5.7C35.836,3.653,28.085,6.63,28.085,6.63Zm3.658,12.4a9.685,9.685,0,0,1-3.912,6.626l-.58-1.772h-6.23l-.58,1.807a11.2,11.2,0,0,1-2.934-3.366,7.407,7.407,0,0,1-.688-2.091c-1.014-12.72,8.946-10.028,8.946-10.028C32.468,9.712,32.25,15.488,31.743,19.031Z" transform="translate(-1.137 -0.358)" fill="#324a5e"/>
                 <g id="Group_22" data-name="Group 22" transform="translate(13.076 3.222)">
                   <path id="SVGCleanerId_0_1_" d="M28.085,6.63c.29-3.26-5-3.047-5-3.047a10.1,10.1,0,0,0-8.874,8.433L15.3,10.74c-1.7,3.65.869,9.921,1.087,10.417,1.34,4.358,4.31,8.362,7.751,8.362s6.411-4,7.751-8.362h0v-.035c.145-.531.29-1.063.4-1.594H32.25c.724-2.835,1.521-5.7,1.521-5.7C35.836,3.653,28.085,6.63,28.085,6.63Zm3.658,12.4a9.685,9.685,0,0,1-3.912,6.626l-.58-1.772h-6.23l-.58,1.807a11.2,11.2,0,0,1-2.934-3.366,7.407,7.407,0,0,1-.688-2.091c-1.014-12.72,8.946-10.028,8.946-10.028C32.468,9.712,32.25,15.488,31.743,19.031Z" transform="translate(-14.213 -3.58)" fill="#324a5e"/>
                 </g>
                 <path id="Path_82" data-name="Path 82" d="M28.085,6.63c.29-3.26-5-3.047-5-3.047a10.1,10.1,0,0,0-8.874,8.433L15.3,10.74c-1.7,3.65.869,9.921,1.087,10.417,1.34,4.358,4.31,8.362,7.751,8.362s6.411-4,7.751-8.362h0v-.035c.145-.531.29-1.063.4-1.594H32.25c.724-2.835,1.521-5.7,1.521-5.7C35.836,3.653,28.085,6.63,28.085,6.63Zm3.658,12.4a9.685,9.685,0,0,1-3.912,6.626l-.58-1.772h-6.23l-.58,1.807c-1.159-.85-3.586-3.224-3.622-5.457-1.014-12.72,8.946-10.028,8.946-10.028C32.468,9.712,32.25,15.488,31.743,19.031Z" transform="translate(-1.137 -0.358)" fill="#324a5e"/>
                 <path id="Path_83" data-name="Path 83" d="M22.244,27.48a3.452,3.452,0,0,0,2.535,1.134,3.327,3.327,0,0,0,2.535-1.134Z" transform="translate(-1.78 -2.748)" fill="#fff"/>
               </g>
             </g>
           </svg>
         </v-avatar>

          &lt;!&ndash;     نمایش قسمت نام کامل و نام کاربری در این قسمت باید قرار بگیرد   &ndash;&gt;
         <div class="fullName">
           <div class="english-name">{{userProfile.username}}</div>
           <div class="persian-name">{{userProfile.first_name}} {{userProfile.last_name}}</div>

         </div>

         &lt;!&ndash; دکمه های مختلف قسمت نوبار شامل نشان دادن تعداد پیام و تنظیمات و گرفتن خروجی اکسل و ضبط زمان دستی در صفحه وب و بزرگتر از 600 پیکسل &ndash;&gt;
         <div class="svgIcon">

&lt;!&ndash;           &lt;!&ndash;  تعداد پیام هایی که آمده است را به ما نشان می دهد  &ndash;&gt;
           <v-btn class="mr-md-4"  rounded icon text ripple>
             <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="18.744" height="22" viewBox="0 0 18.744 22">
               <g id="Group_304" data-name="Group 304" transform="translate(-1157.901 -20)">
                 <g id="noun_Bell_3125167" transform="translate(1157.901 22)">
                   <path id="Path_52" data-name="Path 52" d="M3.35,18.718a2.77,2.77,0,0,0,.93.171c1.247.073,2.495.077,3.734.065a3.355,3.355,0,0,0,1.756,2.331,4.173,4.173,0,0,0,1.865.384c.15,0,.3,0,.467-.016a3.063,3.063,0,0,0,2.122-.838,3.076,3.076,0,0,0,.722-1.917c.532.011,1.066.008,1.593.038.273.016.559.033.856.033a4.926,4.926,0,0,0,1.345-.164A2.758,2.758,0,0,0,20.7,17.052c.442-1.4-.543-2.631-1.328-3.607A12.719,12.719,0,0,1,17.18,9.373c-.171-.535-.308-1.082-.447-1.626a19.492,19.492,0,0,0-.764-2.528A4.968,4.968,0,0,0,13.115,1.9a5.019,5.019,0,0,0-4.066.486A3.823,3.823,0,0,0,7.1,4.973a.789.789,0,0,0,1.554.278,2.346,2.346,0,0,1,1.194-1.5,3.449,3.449,0,0,1,2.744-.363c1.018.358,1.42,1.191,1.914,2.419a17.579,17.579,0,0,1,.7,2.324c.147.578.294,1.156.477,1.724A14.433,14.433,0,0,0,18.2,14.516c.553.685,1.176,1.464.988,2.062a1.244,1.244,0,0,1-.881.7,5.289,5.289,0,0,1-1.683.076c-2.075-.12-4.17-.068-6.193-.024-1.993.046-4.055.092-6.067-.021a1.661,1.661,0,0,1-.423-.057.54.54,0,0,1-.257-.3.481.481,0,0,1-.019-.351,16.192,16.192,0,0,1,1.285-2.146c1.189-1.786,2.538-3.81,2.6-6.648A.786.786,0,0,0,6.785,7a.839.839,0,0,0-.807.774c-.051,2.38-1.213,4.121-2.335,5.806a17.533,17.533,0,0,0-1.41,2.365,2.043,2.043,0,0,0-.013,1.589A2.113,2.113,0,0,0,3.35,18.718Zm7.123.194c.952-.022,1.92-.044,2.891-.049a1.53,1.53,0,0,1-.289.867,1.63,1.63,0,0,1-1.08.344,3,3,0,0,1-1.532-.21,1.768,1.768,0,0,1-.834-.938C9.91,18.92,10.2,18.918,10.473,18.912Z" transform="translate(-2.065 -1.667)" fill="#f3f3f3"/>
                 </g>
                 <circle id="Ellipse_8" data-name="Ellipse 8" cx="3.5" cy="3.5" r="3.5" transform="translate(1168 20)" fill="#ff1010"/>
               </g>
             </svg>
           </v-btn>&ndash;&gt;

&lt;!&ndash;            &lt;!&ndash; این قسمت برای تنظیمات است که با زدن آن به محل ثبت نام رهنمود خواهید شد &ndash;&gt;
           <v-btn @click="changeRouterToSetting" class="mr-md-4"   rounded icon text ripple>
             <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="19.555" viewBox="0 0 20 19.555">
               <g id="Group_14" data-name="Group 14" transform="translate(0 -2.444)">
                 <path id="Path_53" data-name="Path 53" d="M12.285,958.364a.668.668,0,0,0-.278.083l-4,2.222a.667.667,0,0,0-.243.923l1.111,1.854a7.214,7.214,0,0,0-.986,1.805H5.667a.666.666,0,0,0-.667.667v4.444a.667.667,0,0,0,.667.667H7.444a.667.667,0,1,0,0-1.333H6.333v-3.111h2a.667.667,0,0,0,.632-.465,5.793,5.793,0,0,1,1.2-2.208.667.667,0,0,0,.069-.785L9.264,961.5l2.833-1.576,1,1.667a.667.667,0,0,0,.764.292,4.013,4.013,0,0,1,1.132-.187h.014a4.013,4.013,0,0,1,1.132.188.667.667,0,0,0,.764-.292l1-1.667,2.833,1.576-.972,1.625a.667.667,0,0,0,.069.785,5.793,5.793,0,0,1,1.2,2.208.667.667,0,0,0,.632.465h.889a.667.667,0,1,0,0-1.333h-.444a7.216,7.216,0,0,0-.986-1.805l1.111-1.854a.667.667,0,0,0-.243-.924l-4-2.222a.667.667,0,0,0-.9.236l-1.083,1.805a4.928,4.928,0,0,0-1.007-.125h-.014a4.928,4.928,0,0,0-1.007.125L12.9,958.683a.667.667,0,0,0-.618-.319Zm2.493,5.777a4,4,0,1,0,4,4A4.01,4.01,0,0,0,14.778,964.141Zm9.549,1.1a.667.667,0,0,0-.66.681V969.7h-2a.667.667,0,0,0-.632.458,5.792,5.792,0,0,1-1.2,2.208.667.667,0,0,0-.069.785l.979,1.632-2.84,1.576-1-1.673a.667.667,0,0,0-.764-.292,4.029,4.029,0,0,1-1.132.194h-.014a4.033,4.033,0,0,1-1.132-.194.667.667,0,0,0-.764.292l-1,1.673-2.84-1.576.979-1.632a.667.667,0,0,0-.069-.785,5.23,5.23,0,0,1-.792-1.187.667.667,0,1,0-1.194.59,6.767,6.767,0,0,0,.681,1.083l-1.1,1.833a.667.667,0,0,0,.243.931l4,2.222a.667.667,0,0,0,.9-.243l1.083-1.806a4.92,4.92,0,0,0,1.007.132h.014a4.92,4.92,0,0,0,1.007-.132l1.083,1.806a.667.667,0,0,0,.9.243l4-2.222a.667.667,0,0,0,.243-.931l-1.111-1.854a7.208,7.208,0,0,0,.979-1.8h2.229a.667.667,0,0,0,.667-.667v-4.444a.667.667,0,0,0-.674-.681Zm-9.549.236a2.666,2.666,0,1,1-2.667,2.667A2.656,2.656,0,0,1,14.778,965.474Z" transform="translate(-5 -955.918)" fill="#f3f3f3"/>
               </g>
             </svg>
           </v-btn>&ndash;&gt;

&lt;!&ndash;            &lt;!&ndash; باز زدن این دکمه به قسمت خروجی اکسل رهنمود خواهی شد
             که در همین صفحه یک دیالوگی تعریف شده است که در درون این دیالوگ gozareshGiri آمده است. &ndash;&gt;
           <v-btn @click="dialog = true" class="mr-md-4"   rounded icon text ripple>
             <svg  style="cursor: pointer"  class="icon" id="Group_481" data-name="Group 481" xmlns="http://www.w3.org/2000/svg" width="15.84" height="22" viewBox="0 0 15.84 22">
               <g id="Group_480" data-name="Group 480">
                 <path id="Path_2185" data-name="Path 2185" d="M96,55.8V67.244A1.755,1.755,0,0,0,97.756,69h12.329a1.755,1.755,0,0,0,1.756-1.756V55.8a1.759,1.759,0,0,0-1.758-1.756h-2.65a.88.88,0,0,0,.016,1.76h2.632V67.24H97.76V55.8h2.632a.88.88,0,0,0,.016-1.76h-2.65A1.757,1.757,0,0,0,96,55.8Zm12.062-3.773a.879.879,0,0,0,0-1.244l-3.52-3.521a.88.88,0,0,0-1.244,0l-3.52,3.52a.88.88,0,0,0,1.244,1.244l2.018-2.016V61.96a.88.88,0,0,0,1.76,0V50.006l2.017,2.017A.88.88,0,0,0,108.062,52.023Z" transform="translate(-96 -47)" fill="#f3f3f3" fill-rule="evenodd"/>
               </g>
             </svg>
           </v-btn>&ndash;&gt;


         </div>
       </div>-->
        <!-- قسمت سرچ برای اندازه صفحه وب -->
       <div v-if="!$vuetify.breakpoint.xs" class="search">
         <v-btn @click="changeRouterToMainPage" v-if="$route.name==='setting'" rounded icon text ripple>
           <v-icon color="white">mdi-arrow-left </v-icon>
         </v-btn>
<!--         <v-btn v-else class="mr-md-4"  rounded icon text ripple @click="logOut(userProfile.username)" style="display: flex;align-items: center">
            <v-icon color="red">mdi-logout</v-icon>
         </v-btn>-->

         <v-text-field
             style="width: 278px !important; height: 40px !important;display: flex;justify-content: center"
             width="278px"
             height="40px"
             filled
             rounded
             hide-details
             background-color="#F3F3F3">
           <template v-slot:append>
             <v-fade-transition leave-absolute>
               <img
                   width="24"
                   height="24"
                   src="../../assets/svg/searchIcon.svg"
                   alt=""
               >
             </v-fade-transition>
           </template>
         </v-text-field>
       </div>

      <!-- تنظیمات زبان-->
       <v-btn v-if="$vuetify.breakpoint.xs && $route.name!=='setting'" rounded icon text ripple  style="display: flex;align-items: center">
          <v-icon color="white">mdi-dots-vertical </v-icon>
       </v-btn>
       <v-btn @click="changeRouterToMainPage" v-if="($vuetify.breakpoint.xs && $route.name==='setting')" rounded icon text ripple  style="display: flex;align-items: center">
         <v-icon color="white">mdi-arrow-left </v-icon>
       </v-btn>
     </div>
<!--      &lt;!&ndash; این قسمت کد دراور است که در اندازه موبایل کارایی دارد که به کمک همان آیکون منو با کلیک کردن آن فعال می شود. که از سمت راست باز می شود. &ndash;&gt;
     <v-navigation-drawer
         v-model="drawer"
         absolute
         right
         temporary
         v-if="drawer"
     >
        &lt;!&ndash;    این کانتینر برای گرید بندی و هم چنین padding گذاشته شده است . &ndash;&gt;
         <div class="parent-drawer-content">
             <v-btn rounded icon text ripple @click="drawer = false" style="justify-self: flex-end">
               <v-icon size="25" color="red">mdi-close</v-icon>
             </v-btn>

             &lt;!&ndash;     این آواتار برای نشان دادن عکس کاربری است.  &ndash;&gt;
             <div class="profile">
                 &lt;!&ndash;     این آواتار برای نشان دادن عکس کاربری است.  &ndash;&gt;
                 <v-avatar>
                   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="45" height="45" viewBox="0 0 45 45">
                     <defs>
                       <clipPath id="clip-path">
                         <circle id="Ellipse_5" data-name="Ellipse 5" cx="22.5" cy="22.5" r="22.5" transform="translate(1271 47)" :fill="personColor"/>
                       </clipPath>
                     </defs>
                     <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-1271 -47)" clip-path="url(#clip-path)">
                       <g id="man" transform="translate(1271 47)">
                         <path id="Path_1920" data-name="Path 1920" d="M23,0A22.754,22.754,0,0,1,46,22.5,22.754,22.754,0,0,1,23,45,22.754,22.754,0,0,1,0,22.5,22.754,22.754,0,0,1,23,0Z" :fill="personColor"/>
                         <g id="Group_19" data-name="Group 19" transform="translate(5.143 29.835)">
                           <path id="Path_74" data-name="Path 74" d="M25.1,35.709c-.036,0-.072.035-.109.035s-.072-.035-.109-.035Z" transform="translate(-7.134 -33.406)" fill="#84dbff"/>
                           <path id="Path_75" data-name="Path 75" d="M41.3,39.988a23.31,23.31,0,0,1-35.713,0C8.6,36.055,13.2,34.106,16.964,33.15a12.133,12.133,0,0,0,.978,5.386c1.268-2.835,5.506-3.083,5.506-3.083s4.238.248,5.469,3.083a11.606,11.606,0,0,0,.978-5.386C33.7,34.106,38.334,36.055,41.3,39.988Z" transform="translate(-5.591 -33.15)" fill="#84dbff"/>
                         </g>
                         <path id="Path_76" data-name="Path 76" d="M29.729,30.555v.035c0,.354-.181,2.622-5.071,4.429h-.217c-4.89-1.807-5.071-4.075-5.071-4.429v-.035a6.1,6.1,0,0,1,.217-1.382C21,30.909,22.7,32.079,24.55,32.079s3.55-1.169,4.962-2.906A6.1,6.1,0,0,1,29.729,30.555Z" transform="translate(-1.55 -2.917)" fill="#fff"/>
                         <g id="Group_20" data-name="Group 20" transform="translate(16.483 27.638)">
                           <path id="Path_77" data-name="Path 77" d="M30.18,30.709s.254,2.551-5.18,4.535c0,0,4.238.248,5.469,3.083C30.542,38.4,32.969,32.232,30.18,30.709Z" transform="translate(-18.483 -30.709)" fill="#54c0eb"/>
                           <path id="Path_78" data-name="Path 78" d="M19.254,30.709c-2.789,1.524-.362,7.689-.29,7.583,1.268-2.835,5.469-3.083,5.469-3.083C19,33.26,19.254,30.709,19.254,30.709Z" transform="translate(-17.916 -30.709)" fill="#54c0eb"/>
                         </g>
                         <g id="Group_21" data-name="Group 21" transform="translate(13.424 9.577)">
                           <path id="Path_79" data-name="Path 79" d="M31.964,19.737a10,10,0,0,1-2.934,5.811,6.972,6.972,0,0,1-.978.815l-.58-1.807h-6.23l-.58,1.807c-1.159-.85-3.586-3.224-3.622-5.457-1.014-12.72,8.946-10.028,8.946-10.028C32.688,10.418,32.471,16.194,31.964,19.737Z" transform="translate(-14.782 -10.641)" fill="#fff"/>
                           <path id="Path_80" data-name="Path 80" d="M34.564,22.929a3.682,3.682,0,0,1-1.847,1.594,14.824,14.824,0,0,0,.652-1.772v-.035l.435-1.594h-.036c.145-.531.29-1.063.4-1.594a1.045,1.045,0,0,1,.435.142C35.4,20.165,35.361,21.618,34.564,22.929Z" transform="translate(-16.041 -11.529)" fill="#fff"/>
                           <path id="Path_81" data-name="Path 81" d="M17.068,24.535a3.682,3.682,0,0,1-1.847-1.594c-.833-1.311-.833-2.764-.036-3.224.072-.035.109-.071.181-.071a23.765,23.765,0,0,0,1.05,3.154A16.916,16.916,0,0,0,17.068,24.535Z" transform="translate(-14.591 -11.541)" fill="#fff"/>
                         </g>
                         <path id="SVGCleanerId_0" d="M28.085,6.63c.29-3.26-5-3.047-5-3.047a10.1,10.1,0,0,0-8.874,8.433L15.3,10.74c-1.7,3.65.869,9.921,1.087,10.417,1.34,4.358,4.31,8.362,7.751,8.362s6.411-4,7.751-8.362h0v-.035c.145-.531.29-1.063.4-1.594H32.25c.724-2.835,1.521-5.7,1.521-5.7C35.836,3.653,28.085,6.63,28.085,6.63Zm3.658,12.4a9.685,9.685,0,0,1-3.912,6.626l-.58-1.772h-6.23l-.58,1.807a11.2,11.2,0,0,1-2.934-3.366,7.407,7.407,0,0,1-.688-2.091c-1.014-12.72,8.946-10.028,8.946-10.028C32.468,9.712,32.25,15.488,31.743,19.031Z" transform="translate(-1.137 -0.358)" fill="#324a5e"/>
                         <g id="Group_22" data-name="Group 22" transform="translate(13.076 3.222)">
                           <path id="SVGCleanerId_0_1_" d="M28.085,6.63c.29-3.26-5-3.047-5-3.047a10.1,10.1,0,0,0-8.874,8.433L15.3,10.74c-1.7,3.65.869,9.921,1.087,10.417,1.34,4.358,4.31,8.362,7.751,8.362s6.411-4,7.751-8.362h0v-.035c.145-.531.29-1.063.4-1.594H32.25c.724-2.835,1.521-5.7,1.521-5.7C35.836,3.653,28.085,6.63,28.085,6.63Zm3.658,12.4a9.685,9.685,0,0,1-3.912,6.626l-.58-1.772h-6.23l-.58,1.807a11.2,11.2,0,0,1-2.934-3.366,7.407,7.407,0,0,1-.688-2.091c-1.014-12.72,8.946-10.028,8.946-10.028C32.468,9.712,32.25,15.488,31.743,19.031Z" transform="translate(-14.213 -3.58)" fill="#324a5e"/>
                         </g>
                         <path id="Path_82" data-name="Path 82" d="M28.085,6.63c.29-3.26-5-3.047-5-3.047a10.1,10.1,0,0,0-8.874,8.433L15.3,10.74c-1.7,3.65.869,9.921,1.087,10.417,1.34,4.358,4.31,8.362,7.751,8.362s6.411-4,7.751-8.362h0v-.035c.145-.531.29-1.063.4-1.594H32.25c.724-2.835,1.521-5.7,1.521-5.7C35.836,3.653,28.085,6.63,28.085,6.63Zm3.658,12.4a9.685,9.685,0,0,1-3.912,6.626l-.58-1.772h-6.23l-.58,1.807c-1.159-.85-3.586-3.224-3.622-5.457-1.014-12.72,8.946-10.028,8.946-10.028C32.468,9.712,32.25,15.488,31.743,19.031Z" transform="translate(-1.137 -0.358)" fill="#324a5e"/>
                         <path id="Path_83" data-name="Path 83" d="M22.244,27.48a3.452,3.452,0,0,0,2.535,1.134,3.327,3.327,0,0,0,2.535-1.134Z" transform="translate(-1.78 -2.748)" fill="#fff"/>
                       </g>
                     </g>
                   </svg>
                 </v-avatar>
                 &lt;!&ndash;     نمایش قسمت نام کامل و نام کاربری در این قسمت باید قرار بگیرد   &ndash;&gt;
                 <div class="fullName">
                   <div class="english-name">{{userProfile.username}}</div>
                   <div style="color: black"  class="persian-name">{{userProfile.first_name}} {{userProfile.last_name}}</div>

                 </div>
              </div>
              &lt;!&ndash; قسمت سرچ برای اندازه موبایل است  &ndash;&gt;
              <div class="search-mobile">
               <v-text-field
                   style="width: 204px !important; height: 26px !important;display: flex;justify-content: center"
                   width="204"
                   height="26px"
                   filled
                   rounded
                   hide-details
                   dense
                   background-color="#F3F3F3"
                   v-if="drawer"
               >
                 <template v-slot:append>
                   <v-fade-transition leave-absolute>

                     <img
                         width="24"
                         height="24"
                         src="../../assets/svg/searchIcon.svg"
                         alt=""
                     >
                   </v-fade-transition>
                 </template>
               </v-text-field>

             </div>
              &lt;!&ndash; کانتینر برای آیتم های دراور شامل پیام ها و تنظیمات و خروجی اکسل  &ndash;&gt;
              <div class="icon-parent">
&lt;!&ndash;
                 &lt;!&ndash;  تعداد پیام هایی که آمده است را به ما نشان می دهد  &ndash;&gt;
                 <div  class="menu-message">
                   <v-btn class="mr-md-4"  rounded icon text ripple  style="display: flex;align-items: center">
                     <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="18.744" height="22" viewBox="0 0 18.744 22">
                       <g id="Group_304" data-name="Group 304" transform="translate(-1157.901 -20)">
                         <g id="noun_Bell_3125167" transform="translate(1157.901 22)">
                           <path id="Path_52" data-name="Path 52" d="M3.35,18.718a2.77,2.77,0,0,0,.93.171c1.247.073,2.495.077,3.734.065a3.355,3.355,0,0,0,1.756,2.331,4.173,4.173,0,0,0,1.865.384c.15,0,.3,0,.467-.016a3.063,3.063,0,0,0,2.122-.838,3.076,3.076,0,0,0,.722-1.917c.532.011,1.066.008,1.593.038.273.016.559.033.856.033a4.926,4.926,0,0,0,1.345-.164A2.758,2.758,0,0,0,20.7,17.052c.442-1.4-.543-2.631-1.328-3.607A12.719,12.719,0,0,1,17.18,9.373c-.171-.535-.308-1.082-.447-1.626a19.492,19.492,0,0,0-.764-2.528A4.968,4.968,0,0,0,13.115,1.9a5.019,5.019,0,0,0-4.066.486A3.823,3.823,0,0,0,7.1,4.973a.789.789,0,0,0,1.554.278,2.346,2.346,0,0,1,1.194-1.5,3.449,3.449,0,0,1,2.744-.363c1.018.358,1.42,1.191,1.914,2.419a17.579,17.579,0,0,1,.7,2.324c.147.578.294,1.156.477,1.724A14.433,14.433,0,0,0,18.2,14.516c.553.685,1.176,1.464.988,2.062a1.244,1.244,0,0,1-.881.7,5.289,5.289,0,0,1-1.683.076c-2.075-.12-4.17-.068-6.193-.024-1.993.046-4.055.092-6.067-.021a1.661,1.661,0,0,1-.423-.057.54.54,0,0,1-.257-.3.481.481,0,0,1-.019-.351,16.192,16.192,0,0,1,1.285-2.146c1.189-1.786,2.538-3.81,2.6-6.648A.786.786,0,0,0,6.785,7a.839.839,0,0,0-.807.774c-.051,2.38-1.213,4.121-2.335,5.806a17.533,17.533,0,0,0-1.41,2.365,2.043,2.043,0,0,0-.013,1.589A2.113,2.113,0,0,0,3.35,18.718Zm7.123.194c.952-.022,1.92-.044,2.891-.049a1.53,1.53,0,0,1-.289.867,1.63,1.63,0,0,1-1.08.344,3,3,0,0,1-1.532-.21,1.768,1.768,0,0,1-.834-.938C9.91,18.92,10.2,18.918,10.473,18.912Z" transform="translate(-2.065 -1.667)" fill="#707070"/>
                         </g>
                         <circle id="Ellipse_8" data-name="Ellipse 8" cx="3.5" cy="3.5" r="3.5" transform="translate(1168 20)" fill="#707070"/>
                       </g>
                     </svg>
                   </v-btn>
                   <p class="menu-paragraph">پیام ها</p>
                 </div>&ndash;&gt;
&lt;!&ndash;
                 &lt;!&ndash;خط کشیدن و ایجاد فاصله &ndash;&gt;
                 <v-divider class="mobile-divider"></v-divider>

                 &lt;!&ndash; این قسمت برای تنظیمات است که با زدن آن به محل ثبت نام رهنمود خواهید شد &ndash;&gt;
                 <div style="cursor: pointer" @click="changeRouterToSetting" class="menu-message">
                   <v-btn class="mr-md-4"  rounded icon text ripple  style="display: flex;align-items: center" >
                     <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="19.555" viewBox="0 0 20 19.555">
                       <g id="Group_14" data-name="Group 14" transform="translate(0 -2.444)">
                         <path id="Path_53" data-name="Path 53" d="M12.285,958.364a.668.668,0,0,0-.278.083l-4,2.222a.667.667,0,0,0-.243.923l1.111,1.854a7.214,7.214,0,0,0-.986,1.805H5.667a.666.666,0,0,0-.667.667v4.444a.667.667,0,0,0,.667.667H7.444a.667.667,0,1,0,0-1.333H6.333v-3.111h2a.667.667,0,0,0,.632-.465,5.793,5.793,0,0,1,1.2-2.208.667.667,0,0,0,.069-.785L9.264,961.5l2.833-1.576,1,1.667a.667.667,0,0,0,.764.292,4.013,4.013,0,0,1,1.132-.187h.014a4.013,4.013,0,0,1,1.132.188.667.667,0,0,0,.764-.292l1-1.667,2.833,1.576-.972,1.625a.667.667,0,0,0,.069.785,5.793,5.793,0,0,1,1.2,2.208.667.667,0,0,0,.632.465h.889a.667.667,0,1,0,0-1.333h-.444a7.216,7.216,0,0,0-.986-1.805l1.111-1.854a.667.667,0,0,0-.243-.924l-4-2.222a.667.667,0,0,0-.9.236l-1.083,1.805a4.928,4.928,0,0,0-1.007-.125h-.014a4.928,4.928,0,0,0-1.007.125L12.9,958.683a.667.667,0,0,0-.618-.319Zm2.493,5.777a4,4,0,1,0,4,4A4.01,4.01,0,0,0,14.778,964.141Zm9.549,1.1a.667.667,0,0,0-.66.681V969.7h-2a.667.667,0,0,0-.632.458,5.792,5.792,0,0,1-1.2,2.208.667.667,0,0,0-.069.785l.979,1.632-2.84,1.576-1-1.673a.667.667,0,0,0-.764-.292,4.029,4.029,0,0,1-1.132.194h-.014a4.033,4.033,0,0,1-1.132-.194.667.667,0,0,0-.764.292l-1,1.673-2.84-1.576.979-1.632a.667.667,0,0,0-.069-.785,5.23,5.23,0,0,1-.792-1.187.667.667,0,1,0-1.194.59,6.767,6.767,0,0,0,.681,1.083l-1.1,1.833a.667.667,0,0,0,.243.931l4,2.222a.667.667,0,0,0,.9-.243l1.083-1.806a4.92,4.92,0,0,0,1.007.132h.014a4.92,4.92,0,0,0,1.007-.132l1.083,1.806a.667.667,0,0,0,.9.243l4-2.222a.667.667,0,0,0,.243-.931l-1.111-1.854a7.208,7.208,0,0,0,.979-1.8h2.229a.667.667,0,0,0,.667-.667v-4.444a.667.667,0,0,0-.674-.681Zm-9.549.236a2.666,2.666,0,1,1-2.667,2.667A2.656,2.656,0,0,1,14.778,965.474Z" transform="translate(-5 -955.918)" fill="#707070"/>
                       </g>
                     </svg>
                   </v-btn>
                   <p class="menu-paragraph">تنظیمات</p>
                 </div>&ndash;&gt;
&lt;!&ndash;
                 &lt;!&ndash;خط کشیدن و ایجاد فاصله &ndash;&gt;
                 <v-divider class="mobile-divider"></v-divider>

                 &lt;!&ndash; باز زدن این دکمه به قسمت خروجی اکسل رهنمود خواهی شد
                  که در همین صفحه یک دیالوگی تعریف شده است که در درون این دیالوگ gozareshGiri آمده است. &ndash;&gt;

                 <div style="cursor: pointer" @click="dialog = true" class="menu-message">
                   <v-btn class="mr-md-4"  rounded icon text ripple  style="display: flex;align-items: center">
                   <svg  style="cursor: pointer"  class="icon" id="Group_481" data-name="Group 481" xmlns="http://www.w3.org/2000/svg" width="15.84" height="22" viewBox="0 0 15.84 22">
                     <g id="Group_480" data-name="Group 480">
                       <path id="Path_2185" data-name="Path 2185" d="M96,55.8V67.244A1.755,1.755,0,0,0,97.756,69h12.329a1.755,1.755,0,0,0,1.756-1.756V55.8a1.759,1.759,0,0,0-1.758-1.756h-2.65a.88.88,0,0,0,.016,1.76h2.632V67.24H97.76V55.8h2.632a.88.88,0,0,0,.016-1.76h-2.65A1.757,1.757,0,0,0,96,55.8Zm12.062-3.773a.879.879,0,0,0,0-1.244l-3.52-3.521a.88.88,0,0,0-1.244,0l-3.52,3.52a.88.88,0,0,0,1.244,1.244l2.018-2.016V61.96a.88.88,0,0,0,1.76,0V50.006l2.017,2.017A.88.88,0,0,0,108.062,52.023Z" transform="translate(-96 -47)" fill="#707070" fill-rule="evenodd"/>
                     </g>
                   </svg>
                   </v-btn>
                   <p class="menu-paragraph">خروجی اکسل</p>
                 </div>&ndash;&gt;
&lt;!&ndash;
                &lt;!&ndash;خط کشیدن و ایجاد فاصله &ndash;&gt;
                <v-divider class="mobile-divider"></v-divider>

                &lt;!&ndash; بیرون رفتن از سایت&ndash;&gt;
                <div @click="logOut(userProfile.username)" style="cursor: pointer"  class="menu-message">
                  <v-btn class="mr-md-4"  rounded icon text ripple  style="display: flex;align-items: center">
                     <v-icon color="red">mdi-logout</v-icon>
                  </v-btn>
                  <p style="color: red" class="menu-paragraph">خروج</p>
                </div>&ndash;&gt;

              </div>
         </div>
     </v-navigation-drawer>-->
      <v-navigation-drawer
          v-if="drawer"
          v-model="drawer"
          :mini-variant.sync="!$vuetify.breakpoint.smAndDown"
          :permanent="!$vuetify.breakpoint.smAndDown"
          fixed
          right
          :expand-on-hover="!$vuetify.breakpoint.smAndDown"
          :temporary="!$vuetify.breakpoint.smAndUp"
          style=" z-index: 100; max-height: 100vh; justify-content: right !important;"
          :style="getAdminMenu ? 'background-color : #2BDC9A' : 'background-color : #FFFFFF'"
          mini-variant-width="80px"
          :width="240"
      >
        <v-list-item :style="getAdminMenu ? 'justify-content : center' : ''" class="px-2 pt-2" >
          <v-list-item-avatar :size="getAdminMenu ? 48 : 48">
            <random-avatar :url="userProfile.avatar" style="min-width: 100%;" :width="getAdminMenu ? '48px' : '48px'"></random-avatar>

          </v-list-item-avatar>

          <v-list-item-title style="justify-content: center;">
            <span class="name" style="font-size: 1rem;">{{userProfile.username}}</span><br>
            <span class="name" style="font-size: 0.93rem;">{{userProfile.first_name}} {{userProfile.last_name}}</span>
          </v-list-item-title>

        </v-list-item>

        <!-- قسمت سرچ برای اندازه موبایل است  -->
        <v-list-item class="search-mobile" v-if="$vuetify.breakpoint.xs">
          <v-text-field
              style="width: 204px !important; height: 26px !important;display: flex;justify-content: center"
              width="204"
              height="26px"
              filled
              rounded
              hide-details
              dense
              background-color="#F3F3F3"
              v-if="drawer"
          >
            <template v-slot:append>
              <v-fade-transition leave-absolute>

                <img
                    width="24"
                    height="24"
                    src="../../assets/svg/searchIcon.svg"
                    alt=""
                >
              </v-fade-transition>
            </template>
          </v-text-field>

        </v-list-item>

        <v-list dense flat id="adminNav" >
          <v-list-item-group
              color="#00CE81"
              ref="navItems"
              mandatory
              v-model="selectedTab"
              active-class="activeItem">

            <v-list-item value="record" @click="setRoute('record')">
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="19.006" height="20.617" viewBox="0 0 19.006 20.617">
                  <g id="stopwatch" transform="translate(-20)">
                    <g id="Group_12" data-name="Group 12" transform="translate(20)">
                      <g id="Group_11" data-name="Group 11">
                        <path id="Path_43" data-name="Path 43" d="M384.937,14.933l2.187,1.824a.805.805,0,1,0,1.031-1.237L385.969,13.7a.805.805,0,1,0-1.032,1.237Z" transform="translate(-369.965 -12.965)" fill="#5a5a5a"/>
                        <path id="Path_44" data-name="Path 44" d="M33.851,16.944a.8.8,0,0,0,.515-.187l2.187-1.824A.805.805,0,1,0,35.521,13.7L33.335,15.52a.805.805,0,0,0,.516,1.424Z" transform="translate(-32.52 -12.966)" fill="#5a5a5a"/>
                        <path id="Path_45" data-name="Path 45" d="M36.223,4.394a9.431,9.431,0,0,0-5.914-2.749V.805a.805.805,0,1,0-1.611,0v.839a9.5,9.5,0,0,0-5.914,16.188,9.5,9.5,0,0,0,12.351.935.805.805,0,1,0-.955-1.3,7.881,7.881,0,1,1,2.243-2.559.805.805,0,0,0,1.411.777,9.508,9.508,0,0,0-1.611-11.3Z" transform="translate(-20)" fill="#5a5a5a"/>
                        <path id="Path_46" data-name="Path 46" d="M221.534,151.327a.805.805,0,0,0-1.133.119l-2.539,3.138a1.612,1.612,0,1,0,1.252,1.014l2.54-3.138A.805.805,0,0,0,221.534,151.327Z" transform="translate(-208.108 -145.061)" fill="#5a5a5a"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> ثبت ساعت </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item value="dashboard" v-if="userProfile.is_superuser" @click="setRoute('dashboard')">
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="22.341" height="12.06" viewBox="0 0 22.341 12.06">
                  <g id="noun_dashboard_3002722" transform="translate(27.56 11.198)">
                    <path id="Path_47" data-name="Path 47" d="M2.53,16.621H9.563l.005,0a.782.782,0,0,0,.111.007.418.418,0,0,0,.046-.009h6.319c.009,0,.016,0,.023,0l.005,0h7.039a.88.88,0,0,0,.88-.88A11.173,11.173,0,0,0,4,8.884.881.881,0,0,0,5.387,9.967a9.413,9.413,0,0,1,16.8,4.894H16.657a4.028,4.028,0,0,0-.841-1.434l1.677-2.306a.879.879,0,1,0-1.422-1.034l-1.714,2.357a4,4,0,0,0-1.536-.345,4.057,4.057,0,0,0-3.833,2.762H3.45a9.406,9.406,0,0,1,.41-2.016.88.88,0,0,0-1.675-.54,11.186,11.186,0,0,0-.535,3.436A.88.88,0,0,0,2.53,16.621Zm10.292-2.762a2.253,2.253,0,0,1,1.886,1H10.969A2.26,2.26,0,0,1,12.821,13.859Z" transform="translate(-29.21 -15.768)" fill="#5a5a5a"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> داشبورد </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
<!--            <v-list-item>
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
                  <g id="noun_report_1534244" transform="translate(-12.2 -18.5)">
                    <g id="Group" transform="translate(12.2 18.5)" fill="#5a5a5a">
                      <path id="Compound_Path" data-name="Compound Path" d="M52.19,29.1H42.635a.635.635,0,0,0-.635.635V33.7a.635.635,0,0,0,.635.635H52.19a.635.635,0,0,0,.635-.635V29.735A.635.635,0,0,0,52.19,29.1Zm-.635,3.968H43.27v-2.7h8.286Z" transform="translate(-32.54 -25.735)"/>
                      <path id="Compound_Path-2" data-name="Compound Path" d="M36.2,20.722A2.222,2.222,0,0,0,33.978,18.5H20.168a2.222,2.222,0,0,0-2.222,2.222V31.8H14.422A2.222,2.222,0,0,0,12.2,34.024v.984A3.492,3.492,0,0,0,15.692,38.5H31.978A4.254,4.254,0,0,0,36.2,34.278ZM17.946,35.008a2.254,2.254,0,0,1-2.254,2.222,2.222,2.222,0,0,1-2.222-2.222v-.984a.921.921,0,0,1,.952-.952h3.524Zm16.984-.73a2.952,2.952,0,0,1-2.952,2.952H18.39a3.492,3.492,0,0,0,.825-2.222V20.722a.952.952,0,0,1,.952-.952h13.81a.952.952,0,0,1,.952.952Z" transform="translate(-12.2 -18.5)" fill="#5a5a5a"/>
                      <path id="Path" d="M43.635,53.87h5.746a.635.635,0,1,0,0-1.27H43.635a.635.635,0,0,0,0,1.27Z" transform="translate(-33.222 -41.775)"/>
                      <path id="Path-2" data-name="Path" d="M52.556,64.6H43.635a.635.635,0,0,0,0,1.27h8.921a.635.635,0,1,0,0-1.27Z" transform="translate(-33.222 -49.965)"/>
                    </g>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> گزارش </v-list-item-title>
              </v-list-item-content>
            </v-list-item>-->
            <v-list-item value="projects" v-if="userProfile.is_superuser" @click="setRoute('projects')">
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                  <g id="noun_project_management_3014479" data-name="noun_project management_3014479" transform="translate(-20 95.065)">
                    <g id="Layer_2" data-name="Layer 2" transform="translate(20 -95.065)">
                      <path id="Path_48" data-name="Path 48" d="M19.1,5.6H14.6a3.6,3.6,0,0,0-7.2,0H2.9a.9.9,0,0,0-.9.9V19.1a.9.9,0,0,0,.9.9H19.1a.9.9,0,0,0,.9-.9V6.5A.9.9,0,0,0,19.1,5.6ZM11,3.8a1.8,1.8,0,0,1,1.8,1.8H9.2A1.8,1.8,0,0,1,11,3.8Zm7.2,14.4H3.8V11h6.3v.9a.9.9,0,0,0,1.8,0V11h6.3Zm0-9H3.8V7.4H18.2Z" transform="translate(-2 -2)" fill="#5a5a5a"/>
                    </g>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> پروژه </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item value="users" v-if="userProfile.is_superuser" @click="setRoute('users')">
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13.778" viewBox="0 0 20 13.778">
                  <g id="noun_User_1923594" transform="translate(3 48)">
                    <g id="Group_13" data-name="Group 13" transform="translate(-3 -48)">
                      <path id="Path_49" data-name="Path 49" d="M11.537,9c.186-.11.351-.209.5-.3V8.029a2.845,2.845,0,0,1-.812-1.984V5.063a2.849,2.849,0,1,1,5.7,0v.982a2.843,2.843,0,0,1-.812,1.984V8.7c.67.406,1.336.785,2.023,1.163,1.788.982,1.9,1.091,1.858,3.217l-.014.695H16.759a.394.394,0,0,1,0-.789h2.449c.036-1.736.034-1.617-1.452-2.433-.829-.456-1.62-.931-2.433-1.408V7.691a2.085,2.085,0,0,0,.812-1.646V5.063a2.06,2.06,0,1,0-4.12,0v.982a2.084,2.084,0,0,0,.812,1.646V9.143l-.494.3c1.867,1.039,1.826,1.419,1.782,3.547h.419a.394.394,0,0,1,0,.789H.026L.009,13.02c-.053-2.525.052-2.627,2.2-3.807.841-.462,1.661-.934,2.48-1.428V6.9a3.347,3.347,0,0,1-.978-2.36V3.353a3.353,3.353,0,1,1,6.706,0V4.537A3.346,3.346,0,0,1,9.437,6.9v.889c.7.42,1.387.825,2.1,1.218Zm0,.9c-.985-.541-1.931-1.094-2.89-1.674V6.558a2.578,2.578,0,0,0,.978-2.021V3.354a2.564,2.564,0,1,0-5.129,0V4.537a2.578,2.578,0,0,0,.979,2.021V8.229C4.518,8.807,3.57,9.363,2.586,9.9.687,10.947.75,10.836.8,12.989H13.33c.046-2.17.082-2.056-1.791-3.086Z" transform="translate(0 0)" fill="#5a5a5a"/>
                      <path id="Path_50" data-name="Path 50" d="M5.276,4.38a.133.133,0,1,1-.133.133A.133.133,0,0,1,5.276,4.38Z" transform="translate(10.525 9.133)" fill="#5a5a5a" fill-rule="evenodd"/>
                    </g>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> کاربران </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

<!--            <v-list-item @click="routeFunc('costs')">
              <v-list-item-icon>
                <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                     xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg"
                     xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                     xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                     viewBox="0 0 12.7 15.875" version="1.1" x="0px" width="26" height="26" y="0px">
                  <g transform="translate(0,-284.29999)"><path style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1.99999988;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate" d="M 8 3 C 5.2473123 3 3 5.2472945 3 8 L 3 12 C 2.980876 13.352315 5.019124 13.352315 5 12 L 5 8 C 5 6.3207181 6.3207468 5 8 5 L 34.027344 5 C 33.391361 5.8388217 33 6.8708916 33 8 L 33 20 C 32.98088 21.352315 35.019107 21.352315 35 20 L 35 13 L 40 13 C 41.644703 13 43 11.644699 43 10 L 43 8 C 43 5.2472567 40.752698 3 38 3 L 8 3 z M 38 5 C 39.679297 5 41 6.3206803 41 8 L 41 10 C 41 10.571276 40.571264 11 40 11 L 35 11 L 35 8 C 35 6.3206803 36.320697 5 38 5 z M 9.8984375 11.001953 A 1.001567 1.001567 0 0 0 10.001953 13.001953 L 19.998047 13.001953 A 1.0002331 1.0002331 0 0 0 19.998047 11.001953 L 10.001953 11.001953 A 1.0001001 1.0001001 0 0 0 9.8984375 11.001953 z M 23.902344 11.001953 A 1.0013833 1.0013833 0 0 0 23.998047 13.001953 L 28 13.001953 A 1.0002331 1.0002331 0 0 0 28 11.001953 L 23.998047 11.001953 A 1.0001001 1.0001001 0 0 0 23.902344 11.001953 z M 3.984375 14.986328 C 3.4328599 14.993887 2.9924487 15.448454 3 16 L 3 42 C 3 43.644699 4.355294 45 6 45 L 24 45 C 25.351707 45.0189 25.351707 42.981518 24 43 L 6 43 C 5.4287652 43 5 42.571238 5 42 L 5 16 C 5.00771 15.436246 4.5481278 14.977522 3.984375 14.986328 z M 9.9023438 15.001953 A 1.0001001 1.0001001 0 0 0 9.8984375 15.003906 A 1.0015858 1.0015858 0 0 0 10.001953 17.003906 L 15 17.003906 A 1.000252 1.000252 0 1 0 15 15.003906 L 10.001953 15.003906 A 1.0001001 1.0001001 0 0 0 9.9023438 15.001953 z M 10.001953 18.996094 A 1.000252 1.000252 0 1 0 10.001953 20.998047 L 19.998047 20.998047 A 1.000252 1.000252 0 1 0 19.998047 18.996094 L 10.001953 18.996094 z M 23.998047 18.996094 A 1.000252 1.000252 0 1 0 23.998047 20.998047 L 28 20.998047 A 1.000252 1.000252 0 1 0 28 18.996094 L 23.998047 18.996094 z M 10.001953 22.998047 A 1.0002331 1.0002331 0 0 0 10.001953 24.998047 L 15 24.998047 A 1.0002331 1.0002331 0 1 0 15 22.998047 L 10.001953 22.998047 z M 10.001953 26.998047 A 1.000252 1.000252 0 1 0 10.001953 29 L 19.998047 29 A 1.000252 1.000252 0 1 0 19.998047 26.998047 L 10.001953 26.998047 z M 10.001953 31 A 1.000252 1.000252 0 1 0 10.001953 33 L 15 33 A 1.000252 1.000252 0 1 0 15 31 L 10.001953 31 z " transform="matrix(0.26458333,0,0,0.26458333,0,284.29999)"/>
                    <path style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1.99999988;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate" d="M 34.001953 22.998047 C 27.938666 22.998047 23.001953 27.932824 23.001953 33.996094 C 23.001953 40.059401 27.938666 45.003906 34.001953 45.003906 C 40.065242 45.003906 45 40.059401 45 33.996094 C 45 27.932824 40.065242 22.998047 34.001953 22.998047 z M 34.001953 24.998047 C 38.984361 24.998047 43 29.013694 43 33.996094 C 43 38.978494 38.984361 43.001953 34.001953 43.001953 C 29.019546 43.001953 25.001953 38.978494 25.001953 33.996094 C 25.001953 29.013694 29.019546 24.998047 34.001953 24.998047 z M 33.982422 26.984375 A 1.0001001 1.0001001 0 0 0 33 28.003906 L 33 29 L 31.996094 29 C 30.351395 29 29 30.359207 29 32.003906 C 29 33.648643 30.351357 35.001953 31.996094 35.001953 L 33 35.001953 L 33 37.001953 L 31.996094 37.001953 C 31.42478 37.001953 31 36.577173 31 36.005859 A 1.0002459 1.0002459 0 1 0 29 36.005859 C 29 37.650559 30.351357 39.001953 31.996094 39.001953 L 33 39.001953 L 33 40 A 1.0002461 1.0002461 0 1 0 35 40 L 35 39.001953 L 35.996094 39.001953 C 37.640793 39.001953 39.001953 37.650559 39.001953 36.005859 C 39.001953 34.36116 37.640793 33.001953 35.996094 33.001953 L 35 33.001953 L 35 31 L 35.996094 31 C 36.567407 31 37.001953 31.432631 37.001953 32.003906 A 1.0002461 1.0002461 0 1 0 39.001953 32.003906 C 39.001953 30.359207 37.640793 29 35.996094 29 L 35 29 L 35 28.003906 A 1.0001001 1.0001001 0 0 0 33.982422 26.984375 z M 31.996094 31 L 33 31 L 33 33.001953 L 31.996094 33.001953 C 31.42478 33.001953 31 32.57522 31 32.003906 C 31 31.432631 31.42478 31 31.996094 31 z M 35 35.001953 L 35.996094 35.001953 C 36.567407 35.001953 37.001953 35.434546 37.001953 36.005859 C 37.001953 36.577173 36.567369 37.001953 35.996094 37.001953 L 35 37.001953 L 35 35.001953 z " transform="matrix(0.26458333,0,0,0.26458333,0,284.29999)"/></g></svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> هزینه‌ها </v-list-item-title>
              </v-list-item-content>
            </v-list-item>-->

<!--            &lt;!&ndash;  تعداد پیام هایی که آمده است را به ما نشان می دهد  &ndash;&gt;
            <v-list-item>
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 20 22">
                  <g id="Group_304" data-name="Group 304" transform="translate(-1157.901 -20)">
                    <g id="noun_Bell_3125167" transform="translate(1157.901 22)">
                      <path id="Path_52" data-name="Path 52" d="M3.35,18.718a2.77,2.77,0,0,0,.93.171c1.247.073,2.495.077,3.734.065a3.355,3.355,0,0,0,1.756,2.331,4.173,4.173,0,0,0,1.865.384c.15,0,.3,0,.467-.016a3.063,3.063,0,0,0,2.122-.838,3.076,3.076,0,0,0,.722-1.917c.532.011,1.066.008,1.593.038.273.016.559.033.856.033a4.926,4.926,0,0,0,1.345-.164A2.758,2.758,0,0,0,20.7,17.052c.442-1.4-.543-2.631-1.328-3.607A12.719,12.719,0,0,1,17.18,9.373c-.171-.535-.308-1.082-.447-1.626a19.492,19.492,0,0,0-.764-2.528A4.968,4.968,0,0,0,13.115,1.9a5.019,5.019,0,0,0-4.066.486A3.823,3.823,0,0,0,7.1,4.973a.789.789,0,0,0,1.554.278,2.346,2.346,0,0,1,1.194-1.5,3.449,3.449,0,0,1,2.744-.363c1.018.358,1.42,1.191,1.914,2.419a17.579,17.579,0,0,1,.7,2.324c.147.578.294,1.156.477,1.724A14.433,14.433,0,0,0,18.2,14.516c.553.685,1.176,1.464.988,2.062a1.244,1.244,0,0,1-.881.7,5.289,5.289,0,0,1-1.683.076c-2.075-.12-4.17-.068-6.193-.024-1.993.046-4.055.092-6.067-.021a1.661,1.661,0,0,1-.423-.057.54.54,0,0,1-.257-.3.481.481,0,0,1-.019-.351,16.192,16.192,0,0,1,1.285-2.146c1.189-1.786,2.538-3.81,2.6-6.648A.786.786,0,0,0,6.785,7a.839.839,0,0,0-.807.774c-.051,2.38-1.213,4.121-2.335,5.806a17.533,17.533,0,0,0-1.41,2.365,2.043,2.043,0,0,0-.013,1.589A2.113,2.113,0,0,0,3.35,18.718Zm7.123.194c.952-.022,1.92-.044,2.891-.049a1.53,1.53,0,0,1-.289.867,1.63,1.63,0,0,1-1.08.344,3,3,0,0,1-1.532-.21,1.768,1.768,0,0,1-.834-.938C9.91,18.92,10.2,18.918,10.473,18.912Z" transform="translate(-2.065 -1.667)" fill="#707070"/>
                    </g>
                    <circle id="Ellipse_8" data-name="Ellipse 8" cx="3.5" cy="3.5" r="3.5" transform="translate(1168 20)" fill="#707070"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>پیام‌ها</v-list-item-title>
              </v-list-item-content>
            </v-list-item>-->

            <!-- این قسمت برای تنظیمات است که با زدن آن به محل ثبت نام رهنمود خواهید شد -->
            <v-list-item @click="changeRouterToSetting">
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.555" viewBox="0 0 20 19.555">
                  <g id="Group_14" data-name="Group 14" transform="translate(0 -2.444)">
                    <path id="Path_53" data-name="Path 53" d="M12.285,958.364a.668.668,0,0,0-.278.083l-4,2.222a.667.667,0,0,0-.243.923l1.111,1.854a7.214,7.214,0,0,0-.986,1.805H5.667a.666.666,0,0,0-.667.667v4.444a.667.667,0,0,0,.667.667H7.444a.667.667,0,1,0,0-1.333H6.333v-3.111h2a.667.667,0,0,0,.632-.465,5.793,5.793,0,0,1,1.2-2.208.667.667,0,0,0,.069-.785L9.264,961.5l2.833-1.576,1,1.667a.667.667,0,0,0,.764.292,4.013,4.013,0,0,1,1.132-.187h.014a4.013,4.013,0,0,1,1.132.188.667.667,0,0,0,.764-.292l1-1.667,2.833,1.576-.972,1.625a.667.667,0,0,0,.069.785,5.793,5.793,0,0,1,1.2,2.208.667.667,0,0,0,.632.465h.889a.667.667,0,1,0,0-1.333h-.444a7.216,7.216,0,0,0-.986-1.805l1.111-1.854a.667.667,0,0,0-.243-.924l-4-2.222a.667.667,0,0,0-.9.236l-1.083,1.805a4.928,4.928,0,0,0-1.007-.125h-.014a4.928,4.928,0,0,0-1.007.125L12.9,958.683a.667.667,0,0,0-.618-.319Zm2.493,5.777a4,4,0,1,0,4,4A4.01,4.01,0,0,0,14.778,964.141Zm9.549,1.1a.667.667,0,0,0-.66.681V969.7h-2a.667.667,0,0,0-.632.458,5.792,5.792,0,0,1-1.2,2.208.667.667,0,0,0-.069.785l.979,1.632-2.84,1.576-1-1.673a.667.667,0,0,0-.764-.292,4.029,4.029,0,0,1-1.132.194h-.014a4.033,4.033,0,0,1-1.132-.194.667.667,0,0,0-.764.292l-1,1.673-2.84-1.576.979-1.632a.667.667,0,0,0-.069-.785,5.23,5.23,0,0,1-.792-1.187.667.667,0,1,0-1.194.59,6.767,6.767,0,0,0,.681,1.083l-1.1,1.833a.667.667,0,0,0,.243.931l4,2.222a.667.667,0,0,0,.9-.243l1.083-1.806a4.92,4.92,0,0,0,1.007.132h.014a4.92,4.92,0,0,0,1.007-.132l1.083,1.806a.667.667,0,0,0,.9.243l4-2.222a.667.667,0,0,0,.243-.931l-1.111-1.854a7.208,7.208,0,0,0,.979-1.8h2.229a.667.667,0,0,0,.667-.667v-4.444a.667.667,0,0,0-.674-.681Zm-9.549.236a2.666,2.666,0,1,1-2.667,2.667A2.656,2.656,0,0,1,14.778,965.474Z" transform="translate(-5 -955.918)" fill="#707070"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="menu-paragraph">تنظیمات</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-item-group>



        </v-list>

        <template v-slot:append>
          <v-list>
            <!--        فعال کردن ضبط ثبت زمان دستی که با زدن بر روی این دکمه دیالوگی در کامپوننت AutoStartTimeAndStopTime باز خواهد شد
          که این امکان را به ما می دهد که تایمی که کار کردیم را بطور دستی وارد کنیم در صفحه وب و بزرگتر از 600 پیکسل . -->
            <v-list-item @click="openDialogSendTime()">
              <v-list-item-icon>
                <svg class="icon manual-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 11 10.939">
                  <g id="Group_559" data-name="Group 559" transform="translate(-14.03 -110.03)">
                    <g id="Group_631" data-name="Group 631">
                      <path id="Path_2316" data-name="Path 2316" d="M0,0V8.939" transform="translate(19.5 111.03)" fill="none" stroke="#707070" stroke-linecap="round" stroke-width="1.5"/>
                      <line id="Line_36" data-name="Line 36" x2="8.939" transform="translate(15.03 115.5)" fill="none" stroke="#707070" stroke-linecap="round" stroke-width="1.5"/>
                    </g>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  ثبت زمان دستی
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- باز زدن این دکمه به قسمت خروجی اکسل رهنمود خواهی شد
که در همین صفحه یک دیالوگی تعریف شده است که در درون این دیالوگ gozareshGiri آمده است. -->
            <v-list-item @click="dialog = true">
              <v-list-item-icon >
                <svg  id="Group_481" data-name="Group 481" xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 20 20">
                  <g id="Group_480" data-name="Group 480">
                    <path id="Path_2185" data-name="Path 2185" d="M96,55.8V67.244A1.755,1.755,0,0,0,97.756,69h12.329a1.755,1.755,0,0,0,1.756-1.756V55.8a1.759,1.759,0,0,0-1.758-1.756h-2.65a.88.88,0,0,0,.016,1.76h2.632V67.24H97.76V55.8h2.632a.88.88,0,0,0,.016-1.76h-2.65A1.757,1.757,0,0,0,96,55.8Zm12.062-3.773a.879.879,0,0,0,0-1.244l-3.52-3.521a.88.88,0,0,0-1.244,0l-3.52,3.52a.88.88,0,0,0,1.244,1.244l2.018-2.016V61.96a.88.88,0,0,0,1.76,0V50.006l2.017,2.017A.88.88,0,0,0,108.062,52.023Z" transform="translate(-96 -47)" fill="#707070" fill-rule="evenodd"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  خروجی اکسل
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="logOut(userProfile.username)">
              <v-list-item-icon>
                <v-icon color="red">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="color: red">خروج</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-navigation-drawer>
   </div>
    <v-dialog
        transition="dialog-top-transition"
        max-width="300"
        v-model ='dialog'
        multiple
    >
      <gozaresh-giri v-if="originalListProjects" :super-user="userProfile.is_superuser" :projectList="originalListProjects"></gozaresh-giri>
    </v-dialog>
    <manual-times  v-if="dialogsManualTime"  :dialogs="dialogsManualTime" v-on:parentevent="falseDialogs" v-on:updateRow="updateRow" :edit="{}"></manual-times>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import gozareshGiri from "./gozareshGiri";
import manualTimes from "./manualTimes";
import {postLogOut} from "../../api/logOut";
import {bus} from "../../main";
// import user from "../../store/module/
import RandomAvatar from "@/components/randomAvatar";

export default {
  name: "navbar",
  props: {
    user: {}
  },
  components:{
    gozareshGiri,
    manualTimes,
    RandomAvatar
  },
  data: () => ({
    // دیتا دراور برای بایند کردن دراور اندازه موبایل
    drawer: false,

    group: null,

    //دیتا دیالوگ برای بایند کردن به کامپوننت گزارش گیری
    dialog:false,

    //برای ثبت نام زمان دستی
    dialogsManualTime:false,

    mini: true,
    selectedTab: undefined,
  }),
  methods:{
    checkResizeForNav() {
      this.drawer = window.innerWidth > 965;
    },
    changeRouterToMainPage() {
      if (this.$route.name !== 'mainPageUser') {

        this.$router.push('/')
      }
    },
      changeRouterToSetting()
      {
        if(this.$route.name !=='setting')
        {
          this.$router.push('/setting')
        }
      },
    //درخواست های اکشن سمت vuex مثل گرفتن اطلاعات کاربری و لیست پروژه ها برای قسمت گزارش گیری
    // , هم چنین printAlert برای نشان دادن آلرت ها به کاربر
    ...mapActions({
      getUserProfile: 'user/fetchUserInfo',
      getListProjectReq:'listProjects/fetchListProjects',
      printAlert:'alert/printAlert',

    }),
    async logOut(userName){

      try{
        let yes = confirm("آیا می خواهید خارج شوید؟")
        if(yes) {
          await postLogOut({username: userName})
          localStorage.setItem('token','')
          this.$router.push('/login')
        }

      }catch (e) {
        //
      }
    },
    // emit
    // کردن refresh کردن و اضافه کردن به جدول اصلی
    updateRow(){
        bus.$emit('buildData');
    },
    //بازکردن دیالوگ ثبت زمان دستی
    openDialogSendTime(){
      this.dialogsManualTime=true
    },
    //برای بستن دیالوگ از این قسمت استفاده شده است
    falseDialogs(){
      this.dialogsManualTime = false
    },
    setRoute(path){
      if(this.$route.path !== path){
        if (this.userProfile.is_superuser)
          this.$router.replace(`/admin/${path}`)
        else if (this.userProfile.is_superuser !== undefined && !this.userProfile.is_superuser){
          this.$router.replace(`/`)
        }
      }
    },
    async updateNavigation(newValue){
      switch (newValue) {
        case 'users':
          this.selectedTab = 'users';
          break;
        case 'dashboard':
          this.selectedTab = 'dashboard';
          break;
        case 'record':
          this.selectedTab = 'record';
          break;
        case 'projects':
          this.selectedTab = 'projects';
          break;

      }
      // this.selectedTab = this.$route.name;

      await this.$forceUpdate()
    }

    // routeFunc(val){
    //   if(this.$route.name !== val){
    //     this.$router.replace(val)
    //
    //   }
    //   else
    //   //
    // }
  },
  watch: {
    group () {
      this.drawer = false
    },
    // selectedTab(newVal){
    //
    // },
    '$route'(newValue){
      this.updateNavigation(newValue.name);


    },
    // selectedTab(newValue){
    //
    //   if (newValue) {
    //     let isSuperUser = this.userProfile.is_superuser;
    //     localStorage.setItem('oldPath', this.$route.path)
    //     switch (this.selectedTab) {
    //       case "record":
    //
    //         if (isSuperUser && this.$route.path !== "admin/record") {
    //           this.$router.replace('/admin/record')
    //         } else if (!isSuperUser && this.$route.path !== "record") {
    //
    //           this.$router.replace('/record')
    //         }
    //         break;
    //       case "dashboard":
    //         if (this.$route.path !== "admin/dashboard") {
    //           this.$router.replace('/admin/dashboard')
    //         }
    //         break;
    //       case "projects":
    //         if (this.$route.path !== "admin/projects") {
    //           this.$router.replace('/admin/projects')
    //         }
    //         break;
    //       case "users":
    //         if (this.$route.path !== "admin/users") {
    //           this.$router.replace('/admin/users')
    //         }
    //         break;
    //     }
    //   }
    // },
    getAdminMenu() {
      if (this.getAdminMenu) {
        document.getElementsByClassName('activeItem')[0].style.borderColor = '#FFFFFF';

      }
      // this.navDrawerItemsClass = 'activeItemWhite'
      else {
        document.getElementsByClassName('activeItem')[0].style.borderColor = '#00CE81';


      }

    }
  },
  //گرفتن اطلاعات از طریق vuex که پروژه و اسم و نام کاربری
  computed: {
    ...mapGetters({
      userProfile: 'user/getUserProfile',
      originalListProjects:'listProjects/get_listProjects',
      getAdminMenu: 'getAdminMenu'

    }),
    //برای تولید کردن رنگ رندوم از 16 رنگ مختلف برای آواتار عکس کاربری
    personColor() {
      let letters = '2EBFD56789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color
    },
  },
  async mounted() {

    await this.updateNavigation();


    await this.getUserProfile();
    // this.selectedTab = localStorage.getItem('oldPath')

    // نشان دادن اسم و نام کاربری به کاربر که از سمت سرور گرفته می شود .
      // try{
      //   await this.getUserProfile();
      //
      // }catch (e) {
      //    //
      // }
     //گرفتن لیست پروژه ها از سمت سرور در جهت استفاده برای قسمتی که مخصوص گزارش گیری کارکرد هست که طراحی شده است که به عنوان props به آن پاس می دهیم
      try{
        await this.getListProjectReq()
      }catch (e) {
        //
      }

    let flag = this.getAdminMenu
    if (flag) {
      document.getElementsByClassName('activeItem')[0].style.borderColor = '#FFFFFF';
    }
    else {
      document.getElementsByClassName('activeItem')[0].style.borderColor = '#00CE81';
    }
  }

}
</script>
<style>
.navbar .v-input__control{
  height: 40px !important;
}
.navbar .v-input__slot{
  height: 40px !important;
  min-height: unset !important;
  margin-bottom: 0 !important;
}
.navbar .v-text-field--enclosed .v-input__append-inner{
  margin-top: 0 !important;
  height: inherit;
  align-items: center;
}
#adminNav.theme--light.v-sheet{
  color: #00CE81 !important;
  background-color: transparent !important;
}

.v-navigation-drawer__content {
  display: grid;
  align-content: start;
}
.v-navigation-drawer__content div  {
  justify-self: right;
  justify-items: right;
}
.v-navigation-drawer__append {
  display: grid;
}
.v-navigation-drawer__append div {
  justify-self: right;
  justify-items: right;
}
</style>

<style scoped>
.persian-name{
  font-size: 12px;
  font-weight: 200;
}
.search{
  display: flex;
  flex-direction: row-reverse;
  float: left;
  transition: width 0.3s ease-in-out;
  width: 80px;
}
.search:hover {
  width: 240px;
}
.navbar{
  display: grid;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-image: linear-gradient(to right,#2BDC9A,#1DCCBB);
  padding: 13px;
  z-index: 5;
  position: relative;
  grid-template-columns: auto  auto;
  flex-direction: row-reverse;
}
.parent-drawer-content{
  display: grid;
  align-items: center;
  /*justify-content: center;*/
}
.fullName{
  display: flex;
  flex-direction: column;
  margin-right: 16px;
  color: white;
  justify-content: center;
  align-items: flex-start;

}
.logo{
  cursor: pointer;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.logo img{
  position: absolute;
  z-index: 6;
  top: 100%;
  margin-top: 16px;
}
.menu-message{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content:flex-start;
}
.profile{
  display: flex;
  justify-content: center;
  align-items: center;
}
.svgIcon{
  display: flex;
  margin-right: 1rem;
}
.fullName .english-name{
  color: black;
}
@media screen and (max-width: 960px) {
  .search{
    width: 34vw;
  }
  .navbar {
    flex-direction: unset;
  }
  .logo img {
    margin-left: unset !important;
  }
}
@media screen and (max-width: 800px) {
  .svgIcon{
    margin-right: 0;
  }
}
@media screen and (max-width: 599px) {
 /* .parent-drawer-content{
    padding: 16px;
  }
  !*.fullName .english-name{
    color: black;
  }*!
  .navbar{
    display: flex;
    align-items: center;
  }
  .search{
    width: unset;
  }
  .logo{
    grid-column: 4;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo img{
    margin-top: 15px;
  }
  .icon-parent{
    margin-top: 30px;
  }
  .search-mobile{
    height: 64px;
    margin-top: 30px;
  }
  .menu-paragraph{
    margin-top: 18px;
    margin-right: 14px;
  }*/

}

.parent-drawer-content{
  padding: 16px;
}
/*.fullName .english-name{
  color: black;
}*/
.navbar{
  display: flex;
  align-items: center;
}
/*.search{
  width: unset;
}*/
.logo{
  grid-column: 4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo img{
  margin-top: 15px;
  margin-left: -80px;
}
.icon-parent{
  margin-top: 30px;
}
.search-mobile{
  margin-bottom: 16px;
  padding-left: 80px;
}

.name{
  color: #5A5A5A;
}
.activeItem{
  border: #00CE81 1px solid;
  border-top-left-radius: 500px;
  border-bottom-left-radius: 500px;
  border-right-color: transparent;
  /*margin-left: 10%;*/;
}
.activeItemWhite{
  border: #FFFFFF 3px solid;
  border-top-left-radius: 500px;
  border-bottom-left-radius: 500px;
  border-right-color: transparent;
  /*margin-left: 10%;*/;
}

</style>
